/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import { KLARNA_MARKETING_BADGE } from '../../config/constants/images';
import {
  KLARNA_MARKETING_BADGE_TEXT,
  KLARNA_HINT,
} from '../../config/text/text';
import { isIESite } from '../../helpers/pages';
import KlarnaModal from './KlarnaModal';

const KlarnaPlacement = ({ isKlarnaPayInThree, price, sidebar }) => {
  const [showKlarnaModal, setShowKlarnaModal] = useState(false);
  const isIrelandSite = isIESite();
  const ref = useRef(null);

  const onClickHandler = () => {
    setShowKlarnaModal(true);
  };

  return (
    <>
      <div className="klarna-container">
        {!sidebar && (
          <div className="klarna-badge">
            <img
              alt={KLARNA_MARKETING_BADGE_TEXT}
              height="30px"
              src={KLARNA_MARKETING_BADGE}
              width="60px"
            />
          </div>
        )}
        <div className="klarna-text-wrapper">
          <p className="klarna-text">
            {isKlarnaPayInThree
              ? `Make 3 payments of ${isIrelandSite ? '€' : '£'}${(
                  Math.floor((price / 3) * 100) / 100
                ).toFixed(2)}. `
              : `Pay in 30 days. `}
            {sidebar && <span className="klarna-logo">Klarna. </span>}
            <button
              className="klarna-link"
              onClick={onClickHandler}
              type="button"
            >
              Learn More
            </button>
          </p>

          <p className="klarna-hint">{KLARNA_HINT}</p>
        </div>
      </div>
      {showKlarnaModal && (
        <KlarnaModal
          currentRef={ref.current}
          price={price}
          setShowKlarnaModal={setShowKlarnaModal}
          showKlarnaModal={showKlarnaModal}
        />
      )}
      <style jsx>{`
        .klarna-container {
          display: flex;
          align-items: center;
          flex-direction: row;
        }
        .klarna-text-wrapper {
          margin-right: 0px;
        }
        .klarna-text {
          line-height: 1;
          margin: 0;
        }
        .klarna-badge {
          margin-right: 14px;
        }
        .klarna-logo {
          font-family: 'Klarna Headline';
          font-weight: bold;
          letter-spacing: -0.5px;
        }
        .klarna-link {
          text-decoration: underline;
          white-space: nowrap;
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
        }
        .klarna-hint {
          margin: 0;
          opacity: 0.6;
        }
      `}</style>
    </>
  );
};

KlarnaPlacement.propTypes = {
  isKlarnaPayInThree: PropTypes.bool,
  price: PropTypes.number,
  sidebar: PropTypes.bool,
};

KlarnaPlacement.defaultProps = { price: 0, sidebar: false };

export default KlarnaPlacement;
